import { render, staticRenderFns } from "./SyncSidePanel.vue?vue&type=template&id=1e4b46d3&scoped=true&"
import script from "./SyncSidePanel.vue?vue&type=script&lang=ts&"
export * from "./SyncSidePanel.vue?vue&type=script&lang=ts&"
import style0 from "./SyncSidePanel.vue?vue&type=style&index=0&id=1e4b46d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4b46d3",
  null
  
)

export default component.exports